import { render } from "./ProjectMinisterSummary.vue?vue&type=template&id=5355ab9d&scoped=true&ts=true"
import script from "./ProjectMinisterSummary.ts?vue&type=script&lang=ts"
export * from "./ProjectMinisterSummary.ts?vue&type=script&lang=ts"

import "./ProjectMinisterSummary.scss?vue&type=style&index=0&id=5355ab9d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5355ab9d"]])

export default __exports__